<template lang="pug">
    .digital-edit__form
        SvButton.digital-edit__button-top(
            v-show="visibleToTop"
            :prependIcon=`{
                icon: 'arrow-up',
                width: 10,
                height: 15,
            }`
            view="flat"
            text="Наверх"
            @click="scrollToTop"
        )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Название

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="name"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Символьный код

            .digital-edit__form-elements--small
                SvInput(
                    v-model="alias"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Название (Родительный п.)

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="name_genitive"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Название (Предложный п.)

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="name_suggested"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Телефон

            .digital-edit__form-elements--small
                SvInput(
                    v-model="phone"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Телефон бесплатный

            .digital-edit__form-elements--small
                SvInput(
                    v-model="footer_free_phone"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Центр карты

            .digital-edit__form-elements--small
                SvInput(
                    v-model="map_coordinates"
                    color="graylight"
                    :withIcon="false"
                    placeholder="Геокоординаты"
                    :customMask="{regex: '^([-]?[0-9]{1,4})([.][0-9]{1,6})?([,] ([-]?[0-9]{1,4}))([.][0-9]{1,6})?$', placeholder: '', showMaskOnHover: false, showMaskOnFocus: false}"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | gtm

            .digital-edit__form-elements--small
                SvInput(
                    v-model="gtm"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | gaid

            .digital-edit__form-elements--small
                SvInput(
                    v-model="gaid"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Часовой пояс

            .digital-edit__form-elements--small
                SvSelect(
                    v-model="timezone"
                    :items="timezones"
                    view="white"
                    withSearch
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | marquiz_developer

            .digital-edit__form-elements--small
                SvInput(
                    v-model="marquiz_developer"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | marquiz_residential

            .digital-edit__form-elements--small
                SvInput(
                    v-model="marquiz_residential"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | marquiz_tradein

            .digital-edit__form-elements--small
                SvInput(
                    v-model="marquiz_tradein"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Офисы

        .digital-edit__form-item
            span.digital-edit__form-title

            .digital-edit__form-elements
                SvMultipleInputsUni.form-residential-photo__upload(
                    v-model="offices"
                    :inputs="['address', 'address_full', 'coordinates', 'name', 'title',]"
                    :placeholders="['Адрес', 'Полный адрес', 'Геокоординаты', 'Название', 'Полное название',]"
                )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvMap from '@/components/uikit/SvMap.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvDatePicker from '@/components/uikit/SvDatePicker.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvSelectList from '@/components/uikit/SvSelectList.vue';
import SvInputList from '@/components/uikit/SvInputList.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvSelectInputList from '@/components/uikit/SvSelectInputList.vue';
import SvDoubleInputList from '@/components/uikit/SvDoubleInputList.vue';
import {rusToLatin} from '@/helpers/transform';
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvTextarea from '@/components/uikit/SvTextarea.vue';
import SvMultipleInputsUni from '@/components/uikit/SvMultipleInputsUni.vue';
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SolutionEmpty from "@/components/forms/subforms/SolutionEmpty";
import SolutionForm from "@/components/forms/subforms/SolutionForm";

export default {
    name: 'FormCity',

    data() {
        return {
            geoVisible: false,
            visibleToTop: false,
            timezones: [
                'Asia/Aden',
                'Asia/Almaty',
                'Asia/Amman',
                'Asia/Anadyr',
                'Asia/Aqtau',
                'Asia/Aqtobe',
                'Asia/Ashgabat',
                'Asia/Atyrau',
                'Asia/Baghdad',
                'Asia/Bahrain',
                'Asia/Baku',
                'Asia/Bangkok',
                'Asia/Barnaul',
                'Asia/Beirut',
                'Asia/Bishkek',
                'Asia/Brunei',
                'Asia/Chita',
                'Asia/Choibalsan',
                'Asia/Colombo',
                'Asia/Damascus',
                'Asia/Dhaka',
                'Asia/Dili',
                'Asia/Dubai',
                'Asia/Dushanbe',
                'Asia/Famagusta',
                'Asia/Gaza',
                'Asia/Hebron',
                'Asia/Ho_Chi_Minh',
                'Asia/Hong_Kong',
                'Asia/Hovd',
                'Asia/Irkutsk',
                'Asia/Jakarta',
                'Asia/Jayapura',
                'Asia/Jerusalem',
                'Asia/Kabul',
                'Asia/Kamchatka',
                'Asia/Karachi',
                'Asia/Kathmandu',
                'Asia/Khandyga',
                'Asia/Kolkata',
                'Asia/Krasnoyarsk',
                'Asia/Kuala_Lumpur',
                'Asia/Kuching',
                'Asia/Kuwait',
                'Asia/Macau',
                'Asia/Magadan',
                'Asia/Makassar',
                'Asia/Manila',
                'Asia/Muscat',
                'Asia/Nicosia',
                'Asia/Novokuznetsk',
                'Asia/Novosibirsk',
                'Asia/Omsk',
                'Asia/Oral',
                'Asia/Phnom_Penh',
                'Asia/Pontianak',
                'Asia/Pyongyang',
                'Asia/Qatar',
                'Asia/Qostanay',
                'Asia/Qyzylorda',
                'Asia/Riyadh',
                'Asia/Sakhalin',
                'Asia/Samarkand',
                'Asia/Seoul',
                'Asia/Shanghai',
                'Asia/Singapore',
                'Asia/Srednekolymsk',
                'Asia/Taipei',
                'Asia/Tashkent',
                'Asia/Tbilisi',
                'Asia/Tehran',
                'Asia/Thimphu',
                'Asia/Tokyo',
                'Asia/Tomsk',
                'Asia/Ulaanbaatar',
                'Asia/Urumqi',
                'Asia/Ust-Nera',
                'Asia/Vientiane',
                'Asia/Vladivostok',
                'Asia/Yakutsk',
                'Asia/Yangon',
                'Asia/Yekaterinburg',
                'Asia/Yerevan',
                'Europe/Amsterdam',
                'Europe/Andorra',
                'Europe/Astrakhan',
                'Europe/Athens',
                'Europe/Belgrade',
                'Europe/Berlin',
                'Europe/Bratislava',
                'Europe/Brussels',
                'Europe/Bucharest',
                'Europe/Budapest',
                'Europe/Busingen',
                'Europe/Chisinau',
                'Europe/Copenhagen',
                'Europe/Dublin',
                'Europe/Gibraltar',
                'Europe/Guernsey',
                'Europe/Helsinki',
                'Europe/Isle_of_Man',
                'Europe/Istanbul',
                'Europe/Jersey',
                'Europe/Kaliningrad',
                'Europe/Kiev',
                'Europe/Kirov',
                'Europe/Lisbon',
                'Europe/Ljubljana',
                'Europe/London',
                'Europe/Luxembourg',
                'Europe/Madrid',
                'Europe/Malta',
                'Europe/Mariehamn',
                'Europe/Minsk',
                'Europe/Monaco',
                'Europe/Moscow',
                'Europe/Oslo',
                'Europe/Paris',
                'Europe/Podgorica',
                'Europe/Prague',
                'Europe/Riga',
                'Europe/Rome',
                'Europe/Samara',
                'Europe/San_Marino',
                'Europe/Sarajevo',
                'Europe/Saratov',
                'Europe/Simferopol',
                'Europe/Skopje',
                'Europe/Sofia',
                'Europe/Stockholm',
                'Europe/Tallinn',
                'Europe/Tirane',
                'Europe/Ulyanovsk',
                'Europe/Uzhgorod',
                'Europe/Vaduz',
                'Europe/Vatican',
                'Europe/Vienna',
                'Europe/Vilnius',
                'Europe/Volgograd',
                'Europe/Warsaw',
                'Europe/Zagreb',
                'Europe/Zaporozhye',
                'Europe/Zurich',
            ].map(timezone => ({
                id: timezone,
                name: timezone,
            })),
        };
    },

    mounted() {
        window.addEventListener('scroll', () => {
            this.scrolled();
        });
    },

    computed: {
        ...mapGetters({
            current: 'city/getCurrent',
        }),

        id: () => this.current.id,

        name: {
            get() {
                // console.log('this.timezones', this.timezones);
                return this.current.name;
            },
            set(name) {
                this.setValue({name});
                this.setValue({alias: rusToLatin(name).toLowerCase()});
            },
        },

        alias: {
            get() {
                return this.current.alias;
            },
            set(alias) {
                this.setValue({alias});
            },
        },

        footer_free_phone: {
            get() {
                return this.current.footer_free_phone;
            },
            set(footer_free_phone) {
                this.setValue({footer_free_phone});
            },
        },

        gaid: {
            get() {
                return this.current.gaid;
            },
            set(gaid) {
                this.setValue({gaid});
            },
        },

        gtm: {
            get() {
                return this.current.gtm;
            },
            set(gtm) {
                this.setValue({gtm});
            },
        },

        map_coordinates: {
            get() {
                return this.current.map_coordinates;
            },
            set(map_coordinates) {
                this.setValue({map_coordinates});
            },
        },

        marquiz_developer: {
            get() {
                return this.current.marquiz_developer;
            },
            set(marquiz_developer) {
                this.setValue({marquiz_developer});
            },
        },

        marquiz_residential: {
            get() {
                return this.current.marquiz_residential;
            },
            set(marquiz_residential) {
                this.setValue({marquiz_residential});
            },
        },

        marquiz_tradein: {
            get() {
                return this.current.marquiz_tradein;
            },
            set(marquiz_tradein) {
                this.setValue({marquiz_tradein});
            },
        },

        name_genitive: {
            get() {
                return this.current.name_genitive;
            },
            set(name_genitive) {
                this.setValue({name_genitive});
            },
        },

        name_suggested: {
            get() {
                return this.current.name_suggested;
            },
            set(name_suggested) {
                this.setValue({name_suggested});
            },
        },

        offices: {
            get() {
                return this.current.offices;
            },
            set(offices) {
                let v = offices.map(office => {
                    return {
                        ...{
                            address: '',
                            address_full: '',
                            city_id: this.current.id,
                            coordinates: '',
                            name: '',
                            title: '',
                        },
                        ...office,
                    };
                });
                this.setValue({offices: v});
            },
        },

        phone: {
            get() {
                return this.current.phone;
            },
            set(phone) {
                this.setValue({phone});
            },
        },

        timezone: {
            get() {
                return this.current.timezone;
            },
            set(timezone) {
                this.setValue({timezone});
            },
        },
    },

    methods: {
        ...mapMutations({
            setValue: 'city/setValue',
        }),

        scrolled() {
            if (window.pageYOffset > 700) {
                this.visibleToTop = true;
            } else {
                this.visibleToTop = false;
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },

    components: {
        SvRadio,
        SvInput,
        SvButton,
        SvSelect,
        SvMultipleInputsUni,
    },
};
</script>

<style lang="scss">
.digital-edit__button-top {
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 999;
}

.digital-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.digital-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;

    &--start {
        align-items: flex-start;
    }
}

.digital-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.digital-edit__form-item_section-title {
    margin-top: 60px;
}

.digital-edit__form-item_section-title_section-title-first {
    margin-top: 10px;
}

.digital-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.digital-edit__form {
    padding: 50px 0;
}

.digital-edit__form-radio {
    margin-right: 21px;
}

.digital-edit__form-separator {
    min-width: 70px;
    text-align: center;
}

.digital-edit__form-elements--medium {
    width: 495px;

    &.ext_features {
        .sv-input__wrapper {
            width: 100%;
        }

    }
}

.digital-edit__form-elements--flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.digital-edit__form-elements--grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px 40px;
    align-items: flex-start;
    margin-bottom: 10px;

    .sv-checkbox__content {
        white-space: nowrap;
    }
}


.digital-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.digital-edit__search {
    width: 47%;
    min-width: 280px;
}

.digital-edit__section-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
}

.digital-edit-plans__form {
    display: grid;
    grid-template-columns: repeat(4, 260px);
    grid-gap: 30px;
    margin-top: 50px;
}

.mb20 {
    margin-bottom: 20px;
}
</style>
